import React from 'react';
import { getPartnerServiceDeskUrlForGenericHelp } from '@css-xp/ppc-navigation/src/utils/partner-service-desk-utils';

// TODO : the links needs to be transferred to configuration file when it is available
const advCentralChatRoomLink = 'https://atlassian.slack.com/app_redirect?channel=CFJNG3E78';

const cassiChatRoomLink = 'https://atlassian.slack.com/archives/CFJNG3E78';

const partnerPurchaseCenterChatRoomLink = getPartnerServiceDeskUrlForGenericHelp();

// TODO : the links needs to be transferred to configuration file when it is available
const advCentralServiceDeskLink = 'https://hello.atlassian.net/servicedesk/customer/portal/231/group/1034';

// TODO : the links needs to be transferred to configuration file when it is available
const accessRequestLink = 'https://hello.atlassian.net/servicedesk/customer/portal/231/group/1034/create/3198';

const caExceptionRequestLink = 'https://atlassian.slack.com/app_redirect?channel=C01UANZAVP1';

type AnchorLinkProps = {
  children: React.ReactNode;
  href: string;
} & Partial<React.AnchorHTMLAttributes<HTMLAnchorElement>>;

export const AnchorLink = ({ children, href, ...otherLinkProps }: AnchorLinkProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer" {...otherLinkProps}>
    {children}
  </a>
);

interface LinkProps {
  children?: React.ReactNode;
  chatRoomLink?: string;
  serviceDeskLink?: string;
}

const appNameChatRoomMap = new Map([
  ['ac', advCentralChatRoomLink],
  ['cassi', cassiChatRoomLink],
  ['ppc', partnerPurchaseCenterChatRoomLink],
]);

const appNameChatRoomContentMap = new Map([
  ['ac', '#help-advocate-central channel'],
  ['cassi', '#help-cassi channel'],
  ['ppc', 'Partner Service Desk'],
]);

const defaultChatRoom = appNameChatRoomMap.get(process.env.APP_NAME ?? '') ?? advCentralChatRoomLink;
const defaultChatRoomContent =
  appNameChatRoomContentMap.get(process.env.APP_NAME ?? '') ?? '#help-advocate-central channel';

export const ChatRoomLink = ({ children = defaultChatRoomContent, chatRoomLink = defaultChatRoom }: LinkProps) => (
  <AnchorLink href={chatRoomLink}>{children}</AnchorLink>
);

const appNameServiceDeskLinkMap = new Map([
  ['ac', advCentralServiceDeskLink],
  ['cassi', advCentralServiceDeskLink],
]);

const defaultServiceDeskLink = appNameServiceDeskLinkMap.get(process.env.APP_NAME ?? '') ?? advCentralServiceDeskLink;

export const ServiceDeskLink = ({ children = 'Service Desk', serviceDeskLink = defaultServiceDeskLink }: LinkProps) => (
  <AnchorLink href={serviceDeskLink}>{children}</AnchorLink>
);

export const AccessRequestLink = ({ children = 'Access Request' }: LinkProps) => (
  <AnchorLink href={accessRequestLink}>{children}</AnchorLink>
);

export const CAExceptionRequestLink = ({ children = '#ca_exception_requests' }: LinkProps) => (
  <AnchorLink href={caExceptionRequestLink}>{children}</AnchorLink>
);
